import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'
import { ZodError } from 'zod'

import Loader from '@/components/Atoms/Loader/Loader'
import TreeEntityCreationModal from '@/components/EntityCreationModals/TreeEntityCreationModal/TreeEntityCreationModal'
import TreeTiles from '@/components/TreeTiles/TreeTiles'
import { GENERAL_ERRORS_MESSAGES } from '@/constants'
import { categorySchema } from '@/schemas'
import { useTreeTilesStore } from '@/stores/feed/treeTilesStore'
import api from '@/utils/api/api'
import getGeneralErrorMessage from '@/utils/api/errors/getGeneralErrorMessage'
import { cleanCategoryTree } from '@/utils/catalog/cleanDescription'

import cn from './CategoriesCatalog.module.scss'

function CategoriesCatalog() {
  const [open, setOpen] = useState(false)
  const [loadingError, setLoadingError] = useState('')
  const [loading, setLoading] = useState(false)
  const [isTreeReady, setIsTreeReady] = useState(false)

  const { categoriesTree: tree, setCategoriesTree: setTree } =
    useTreeTilesStore((state) => state)

  useEffect(() => {
    if (!tree.length) {
      setLoading(true)
      setLoadingError('')
      setIsTreeReady(false)

      api
        .get('/categories/root-trees')
        .then((response) => {
          const treeData = response.data.trees || response.data
          const validatedCategories = categorySchema.array().parse(treeData)
          const cleanedData = cleanCategoryTree(validatedCategories)
          setTree(cleanedData)
        })
        .catch((error) => {
          if (error instanceof AxiosError) {
            setLoadingError(getGeneralErrorMessage(error))
          } else if (error instanceof ZodError) {
            setLoadingError(GENERAL_ERRORS_MESSAGES.ZOD_ERROR)
          } else {
            setLoadingError(GENERAL_ERRORS_MESSAGES.DEFAULT_ERROR)
          }
        })
        .finally(() => {
          setLoading(false)
          setIsTreeReady(true)
        })
    } else {
      setIsTreeReady(false)
      setTimeout(() => setIsTreeReady(true), 100)
    }
  }, [tree.length, setTree])

  return (
    <section className={cn.categoriesCatalog}>
      <TreeEntityCreationModal
        open={open}
        setOpen={setOpen}
        externalTree={tree}
        setExternalTree={setTree}
        treeType="categories"
      />

      {(loading || !isTreeReady) && (
        <Loader loaderType="modal" isModalOpen={true} />
      )}

      {!loading && !loadingError && isTreeReady && (
        <div className={cn.inner}>
          <span className={cn.title}>Каталог по категориям</span>
          <TreeTiles
            tree={tree}
            treeLoading={false}
            loadingError={loadingError}
            setTree={setTree}
            actionButton={
              <button className={cn.actionButton} onClick={() => setOpen(true)}>
                Добавить категорию
              </button>
            }
          />
        </div>
      )}

      {!loading && !!loadingError && (
        <div className={cn.inner}>
          <p className={cn.errorMessage}>{loadingError}</p>
        </div>
      )}
    </section>
  )
}

export default CategoriesCatalog
